import { render, staticRenderFns } from "./CompanyDateNewsDialog.vue?vue&type=template&id=5b967851&scoped=true"
import script from "./CompanyDateNewsDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDateNewsDialog.vue?vue&type=script&lang=js"
import style0 from "./CompanyDateNewsDialog.vue?vue&type=style&index=0&id=5b967851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b967851",
  null
  
)

export default component.exports